import React, { useState, useContext, useEffect } from 'react';
import { useSelector, shallowEqual } from "react-redux";

//COMPONENTES REUTILIZABLES
import Documentacion from './components/Documentacion';
import DatosPersonales from './components/DatosPersonales';
import Domicilio from './components/Domicilio';

//CONTEXTO
import { PreInscripcionUIContext } from '../PreInscripcionUIContext';

const Persona = (props) => {
    const { aspirante } = useSelector(
        (state) => ({ aspirante: state.aspirante }),
        shallowEqual
    );
    const {
        //aspiranteInformacion,
        actionsLoading: actionsLoadingAspirante,
        //error: errorAspirante
    } = aspirante;

    const { pasoUno } = useSelector(
        (state) => ({ pasoUno: state.pasoUno }),
        shallowEqual
    );
    const { listLoadingResponsables } = pasoUno;

    const { tipo, posicion } = props;
    const { cantidadResponsables } = useContext(PreInscripcionUIContext);
    const [cantidad, setCantidad] = useState(cantidadResponsables());
    const [verDatosPersonales, setVerDatosPersonales] = useState(false);
    const [verDomicilio, setVerDomicilio] = useState(false);
    //const [buscando, setBuscando] = useState(false);
    let buscando = false;
    useEffect(() => {
        if (tipo === "responsable" && posicion === cantidad) {
            setVerDatosPersonales(false);
            setVerDomicilio(false);
        };
    }, [tipo, posicion, cantidad]);

    useEffect(() => {
        //setBuscando(!!actionsLoadingAspirante || !!listLoadingResponsables);
        buscando = !!actionsLoadingAspirante || !!listLoadingResponsables;
    }, [actionsLoadingAspirante, listLoadingResponsables]);

    return (
        <>
            <Documentacion
                setCantidad={setCantidad}
                verDatosPersonales={verDatosPersonales}
                setVerDatosPersonales={setVerDatosPersonales}
                setVerDomicilio={setVerDomicilio}
                buscando={!!actionsLoadingAspirante || !!listLoadingResponsables}
                {...props}
            />
            {(!actionsLoadingAspirante && !listLoadingResponsables) && 
                <>
                    {verDatosPersonales && <DatosPersonales setCantidad={setCantidad} verDomicilio={verDomicilio} setVerDomicilio={setVerDomicilio} {...props} />}
                    {verDomicilio && <Domicilio setCantidad={setCantidad} {...props} />}
                </>
            }
        </>
    )
};

export default Persona;